var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11445_125560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79199 2.83301H2.83366C2.45794 2.83301 2.0976 2.98226 1.83192 3.24794C1.56625 3.51362 1.41699 3.87395 1.41699 4.24967V14.1663C1.41699 14.5421 1.56625 14.9024 1.83192 15.1681C2.0976 15.4338 2.45794 15.583 2.83366 15.583H12.7503C13.126 15.583 13.4864 15.4338 13.7521 15.1681C14.0177 14.9024 14.167 14.5421 14.167 14.1663V9.20801",
    stroke: "#019DF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1045 1.77116C13.3863 1.48936 13.7685 1.33105 14.167 1.33105C14.5655 1.33105 14.9477 1.48936 15.2295 1.77116C15.5113 2.05295 15.6696 2.43514 15.6696 2.83366C15.6696 3.23217 15.5113 3.61436 15.2295 3.89616L8.50033 10.6253L5.66699 11.3337L6.37533 8.50032L13.1045 1.77116Z",
    stroke: "#019DF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11445_125560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.0231dd3ba27361aa943f4fedd6390b2d.svg";
export { ForwardRef as ReactComponent };